import { useEffect, useState } from "react";

/**
 * Tracks whether an image URL can actually be shown. A link to a stored file is only as good as
 * the moment it was issued: a time-limited SAS expires, and a logo replaced by a manager is
 * deleted immediately. Callers render the image while `showImage` holds and fall back to
 * whatever they showed before the image existed once it does not.
 */
export const useImageWithFallback = (src: string | null | undefined) => {
  const [failed, setFailed] = useState(false);

  // A new URL is a new chance: a link that failed must not poison the one that replaced it.
  useEffect(() => {
    setFailed(false);
  }, [src]);

  return {
    showImage: !!src && !failed,
    onError: () => setFailed(true),
  };
};
